<template>
  <div class="w-full h-screen flex flex-col">
    <div class="h-screen w-full flex flex-col">
      <div class="bg-primary py-6 w-full text-center">
        <div class="pt-6">
          <img class="papsi-main-logo" v-bind:src="image" />
        </div>
        <div
          v-text="lang('lbl_0000141')"
          class="text-white font-bold text-xl mt-6 uppercase"
        ></div>
        <div
          v-text="lang('lbl_0000142')"
          class="text-white text-sm text-md italic mt-1"
        ></div>
      </div>
      <div class="w-full h-full pb-6">
        <ContentWrapperControl class="mt-6">
          <div class="mb-4">
            <TextControl
              @typing="typing"
              v-bind:value="username"
              v-bind:placeholder="lang('lbl_0000041')"
              type="login_username"
              name="username"
              :maxlength="24"
            />
          </div>
          <div class="mb-4">
            <TextControl
              @typing="typing"
              v-bind:value="password"
              v-bind:placeholder="lang('lbl_0000042')"
              type="password"
              name="password"
              :maxlength="24"
            />
          </div>
          <div class="flex mb-4 text-md">
            <div class="font-semibold flex-1 text-sm">
              <router-link to="/signup" class="text-primary no-underline">
                {{ lang("lbl_0000143") }}
              </router-link>
            </div>
            <div class="font-semibold flex-1 text-right text-sm">
              <router-link to="/help" class="text-primary no-underline">
                {{ lang("lbl_0000144") }}
              </router-link>
            </div>
          </div>
          <div>
            <ButtonControl v-on:click="login" v-bind:disabled="disabled">
              {{ lang("lbl_0000043") }}
            </ButtonControl>
          </div>
        </ContentWrapperControl>
      </div>
      <div
        class="text-center leading-normal text-grey text-xs w-full pb-3 papsi-curr-version"
      >
        <span v-text="version"></span>
      </div>
    </div>
  </div>
</template>

<script>
import ContentWrapperControl from "./../components/controls/ContentWrapperControl.vue";
import ButtonControl from "./../components/controls/ButtonControl.vue";
import TextControl from "./../components/controls/TextControl.vue";
import mixin from "./../mixin.js";
import User from "./../services/User.js";

export default {
  mixins: [mixin],
  components: {
    ButtonControl,
    ContentWrapperControl,
    TextControl,
  },
  data() {
    return {
      type: 1,
      image: "",
      version: "",
      username: "",
      password: "",
      disabled: true,
      name: null,
      email: null,
      mobile_no: null,
      ga_mode: process.env.VUE_APP_ELECTION_ENABLED.toString() == "true",
    };
  },
  mounted() {
    this.$emit("hidenavbar");
    this.$emit("checkauth", false);
    this.$emit("nofooter", true);
    this.version = this.lang("lbl_0000044") + " " + process.env.VUE_APP_VERSION;
    this.image = this.getMediaPath("/logo/papsi-mobile.jpg");

    let state = this.$store.state;

    if (state.login && !state.info.email && !state.info.mobile) {
      this.logout();
      return;
    }

    if (
      state.login &&
      state.pin_login &&
      (!state.config.status ||
        (state.config.find((item) => item.type === 2)?.status === true &&
          state.otp_login))
    ) {
      this.$emit("login");
      this.$router.push("/dashboard");
      return;
    }

    if (
      state.login &&
      state.pin_login &&
      state.config.find((item) => item.type === 2)?.status === true &&
      !state.otp_login
    ) {
      this.$router.push("/user/login/otp");
      return;
    }

    if (state.login && !state.has_pin) {
      this.$router.push("/user/enroll/pin");
      return;
    }

    if (
      state.login &&
      state.has_pin &&
      (!state.pin_login || state.pin_update)
    ) {
      if (state.forgot_pin) {
        state.forgot_pin = false;
      }
      this.$router.push("/user/login/pin");
      return;
    }
  },
  methods: {
    typing(obj) {
      this[obj.name] = obj.value;
      this.enableButton();
    },
    enableButton() {
      this.disabled = this.username.length == 0 || this.password.length == 0;
    },
    login() {
      this.$emit("showloader");
      User.authenticate(this.username, this.password)
        .then((response) => {
          this.createSession(response.data.data);
        })
        .catch((error) => {
          this.password = "";
          this.$emit("error", error);
        });
    },
    logout() {
      this.$emit("showloader");

      User.logout()
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => {
          this.$emit("hidenavbar");
          this.$emit("logout");
          this.$emit("hideloader");
          this.inputting_pin = false;
          this.inputting_otp = false;
          this.destroyCookies();
          this.resetUserData();
          this.$router.push("/");
        });
    },
    createSession(data) {
      User.createSession({
        type: 1,
        hash: data.hash,
        username: this.username,
        password: this.password,
      })
        .then((response) => {
          let info = response.data.data;
          this.setUserData(info);
          this.makeCookie(info.hash, true);
          this.$emit("shownavbar", {
            title: this.lang("lbl_0000281"),
            show: true,
            back: true,
            type: "logout",
          });

          this.email = info.info.email;
          this.mobile_no = info.info.mobile;
          this.name = info.info.first_name;

          if (!info.info.email || !info.info.mobile) {
            this.$router.push("/user/info/checklist");
            return;
          }
          
          if (!info.has_pin) {
            this.$router.push("/user/enroll/pin");
            return;
          }

          // if(this.ga_mode) {
          //   this.$store.state.ga.user.can_participate = info.ga.can_participate;
          //   this.$store.state.ga.user.has_participated = info.ga.has_participated;
          //   this.$store.state.ga.user.has_registered = info.ga.has_registered;
          //   console.log("User data updated in store:", this.$store.state.ga.user);
          // }

          // that.inputting_pin = true;
          this.$router.push("/user/login/pin");
        })
        .catch((error) => {
          this.password = "";
          this.$emit("error", error);
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },
  },
};
</script>

<style scoped>
.papsi-main-logo {
  width: 100%;
  max-width: 200px;
}
.papsi-curr-version {
  bottom: 0px;
}
</style>
